const intialState = {};

export default (state = intialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
